export default __webpack_public_path__ + "static/media/item1.31d09918.png";